module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/schedule-2-ff5306ac7a3e2222d49228f35e2a510f.jpg";